import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

interface LocationCardActionsProps {
  children: React.ReactNode;
}

const ActionsRoot = styled(Box)(({ theme }) => ({
  gridArea: "actions",
  marginTop: 14,
  // xs: equal-width buttons filling the card, wrapping to a second row when
  // there are more than fit (44px touch targets).
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(96px, 1fr))",
  gap: 8,
  "& > span": { display: "flex !important" }, // tooltip wrappers around buttons
  "& .MuiButton-root": { width: "100%", minHeight: 44 },
  // SM: a right-aligned row under the fields
  [theme.breakpoints.up("sm")]: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    alignItems: "center",
    paddingTop: 12,
    borderTop: "1px solid #eef1f4",
    "& .MuiButton-root": { width: "auto", minHeight: 0 },
  },
  // MD+: top-right, beside the name
  [theme.breakpoints.up("md")]: {
    marginTop: 0,
    paddingTop: 0,
    borderTop: 0,
    alignSelf: "start",
    maxWidth: 440,
  },
}));

/**
 * Button slot for a `LocationCard`. Accepts any React children — typically
 * MUI `Button` or legacy `.ss-button-*` buttons. Has no opinion about which
 * actions appear; callers compose this based on the location's status.
 *
 * Accessibility: renders as a `group` so screen readers announce the button
 * set as a related unit.
 */
const LocationCardActions = ({ children }: LocationCardActionsProps) => (
  <ActionsRoot role="group" aria-label="Location actions">
    {children}
  </ActionsRoot>
);

export default LocationCardActions;

